<template>
    <div class="company-detail-box">
        <div class="header">
            <span class="font" @click="bak"><span class="el-icon-arrow-left icon"></span>返回</span> <span
                class="shu">|</span> <span class="font-text">{{ $route.query.companyName }}</span>
            <span class="export"><a :href="href"><span class="el-icon-download"></span>导出统计数据</a></span>
            <span class="export">
                <el-select v-model="value" @change="pointByHour" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </span>
        </div>

        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">用户管理</el-menu-item>
            <el-menu-item index="6">部门管理</el-menu-item>
            <el-menu-item index="2">产品管理</el-menu-item>
            <el-menu-item index="3">设备管理</el-menu-item>
            <el-menu-item index="7">跟踪记录</el-menu-item>
            <el-menu-item index="4">分析统计</el-menu-item>
            <!-- <el-menu-item index="5">系统设置</el-menu-item> -->
            <el-menu-item index="8">企业设置</el-menu-item>
        </el-menu>

        <div class="menu-content">
            <div v-if="showCom">
                <company></company>
            </div>

            <div v-if="showWeP">
                <weProduct></weProduct>
            </div>

            <div v-if="showDev">
                <device></device>
            </div>

            <Static :comId="$route.query.companyId" v-if="showFx"></Static>

            <!-- <div v-if="showSystem">
        <System :comId="$route.query.companyId"></System>
      </div> -->

            <!-- 部门管理 -->
            <DepartManage v-if="activeIndex == 6" />

            <!-- 跟踪记录 -->
            <TrackManage v-if="activeIndex == 7" />

            <!-- 企业设置 -->
            <CompamySetting v-if="activeIndex == 8" :editLevel="false" />
        </div>

    </div>
</template>
<script>
import company from '../companys/Companyed'
import device from '../companys/Device'
import weProduct from '../companys/WeProduct'
import Static from '../companys/static'
import System from '../companys/system'
import CompamySetting from '../companys/CompamySetting'
import DepartManage from '../companys/DepartManage/index.vue'
import TrackManage from '../companys/TrackManage/index'
import { API__code, API_Admin } from '../../../api/index.js'

export default {

    data() {
        return {
            activeIndex: '',
            showCom: true,
            showDev: false,
            showWeP: false,
            showFx: false,
            showSystem: false,
            href: '',
            options: [{
                value: '1',
                label: '最近一个月'
            }, {
                value: '3',
                label: '最近三个月'
            }, {
                value: '6',
                label: '最近半年'
            }, {
                value: '12',
                label: '最近一年'
            }],
            value: '',
            count: 1,
            token: '',
            checkCode: '',
        }
    },
    components: {
        company,
        device,
        weProduct,
        Static,
        System,
        CompamySetting,
        DepartManage,
        TrackManage
    },
    created() {
        this.getCookie();
        this.href = API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
    },
    methods: {

        //读取cookie
        getCookie: function () {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; ');
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('=');
                    if (arr2[0] == 'dnnyptadmin_token') {
                        this.token = arr2[1];
                    } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                        this.checkCode = arr2[1];
                    }
                }
            }
        },

        pointByHour(val) {
            this.count = val;
            this.href = API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
        },

        bak: function () {
            this.$router.push({
                path: '/probationCustom',
                query: {
                    dynamicTags: this.$route.query.dynamicTags,
                    souchs: this.$route.query.souchs,
                    type: 1,
                    pageNumber: this.$route.query.pageNumber,
                    pageSize: this.$route.query.pageSize,
                    companyName: this.$route.query.companyName,
                    searchText: this.$route.query.searchText,
                    status: this.$route.query.status,
                    managerAdminuserName: this.$route.query.managerAdminuser,
                    managerAdminuser: this.$route.query.managerAdminuser,
                    distributionStatus: this.$route.query.distributionStatus,
                    regionCode: this.$route.query.regionCode,
                    successfulManager:this.$route.query.successfulManager,
                    agencyManager:this.$route.query.agencyManager,
                }
            });
        },
        handleSelect(key, keyPath) {
            this.showCom = false;
            this.showWeP = false;
            this.showDev = false;
            this.showFx = false;
            this.showSystem = false;
            if (key == '1') {
                this.showCom = true;
                sessionStorage.setItem('admin_menu', '1');
            } else if (key == '2') {
                this.showWeP = true;
                sessionStorage.setItem('admin_menu', '2');
            } else if (key == '3') {
                this.showDev = true;
                sessionStorage.setItem('admin_menu', '3');
            } else if (key == '4') {
                this.showFx = true;
                sessionStorage.setItem('admin_menu', '4');
            } else if (key == '5') {
                this.showSystem = true;
                sessionStorage.setItem('admin_menu', '5');
            }
            sessionStorage.setItem('admin_menu', key)
            this.activeIndex = key;

        }
    },

    mounted() {
        this.activeIndex = sessionStorage.getItem('admin_menu');
        this.activeIndex = this.activeIndex ? this.activeIndex : '1'
        if (this.activeIndex == '2') {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = true;
            this.showFx = false;
            this.showSystem = false
            sessionStorage.setItem('admin_menu', 2);
        } else if (this.activeIndex == '3') {
            this.showDev = true;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false
            sessionStorage.setItem('admin_menu', 3);
        } else if (this.activeIndex == '4') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = true;
            this.showSystem = false
            sessionStorage.setItem('admin_menu', 4);
        } else if (this.activeIndex == '5') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = true
            sessionStorage.setItem('admin_menu', 5);
        } else {
            this.showCom = true;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false
            sessionStorage.setItem('admin_menu', 1);
        }
        if (['6', '7', '8'].includes(this.activeIndex)) {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false
            sessionStorage.setItem('admin_menu', this.activeIndex);
        }
    },

}
</script>

<style lang="scss" scoped>
.company-detail-box {
    padding: 0 20px;
    height: 100%;
    box-sizing: border-box;
    background: #fff;

    .menu-content {
        width: 100%;
        height: calc(100% - 120px);
        overflow: auto;
        box-sizing: border-box;
    }

    .header {
        background: #fff;
    }

    .el-menu--horizontal>.el-menu-item {
        color: #666;
    }

    .el-form-item {
        margin-bottom: 0;
    }

}

.header {
    height: 64px;
    line-height: 64px;

    background: #FFFFFF;
    // padding: 0px 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8E9EB;
    ;

    .font {
        color: #666;
        font-size: 14px;
        position: relative;
        top: -2px;
        margin-left: 10px;
        cursor: pointer;
    }

    .font-text {
        color: #666;
        font-size: 14px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }

    .font:hover {
        color: #f66b3d;
    }

    .shu {
        height: 50px;
        font-size: 27px;
        border-left: 1px solid #E8E9EB;
        margin-left: 15px;
    }

    .icon {
        margin-right: 5px;
    }
}

.export {
    float: right;
    color: #2196F3;
    font-size: 14px;
    position: relative;
    top: 1px;
    margin-right: 20px;
    cursor: pointer;

    a {
        text-decoration: none;
        color: #2196F3;
    }
}
</style>



// WEBPACK FOOTER //
// probationView.vue?b271a6aa